import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteEnquiryAPI, fetchEnquiriesAPI, updateEnquiryStatusAPI } from "./enquiryAPI";

// Fetch Enquiries Thunk
export const fetchEnquiries = createAsyncThunk("enquiries/fetchEnquiries", async (_, {rejectWithValue}) => {
    try {
        const response = await fetchEnquiriesAPI()
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})

// Additional thunks (e.g., deleteEnquiry, updateEnquiryStatus) can be added here similarly
export const deleteEnquiry = createAsyncThunk("enquiries/deleteEnquiry", async (id, {rejectWithValue}) => {
    try {
        const response = await deleteEnquiryAPI(id)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})   

// Update Enquiry Status Thunk
export const updateEnquiryStatus = createAsyncThunk("enquiries/updateEnquiryStatus", async (body, {rejectWithValue}) => {
    try {
        const response = await updateEnquiryStatusAPI(body)
        return response
    } catch (error) {
        return rejectWithValue(error)
    }
})